import React, {useState, useEffect, useRef, useContext} from 'react'
import { MobileView } from 'react-device-detect';
import { useFetch } from '../../api/FetchApiData';
import { MediaUrl } from '../../utils/Media';
import Select from 'react-select';
import { isMobile } from 'react-device-detect';
import { UserContext } from '../../../AppContextProvider';
import { useNavigate } from 'react-router-dom';
import { TeachButton } from '../../utils/ButtonLoader';
if (isMobile)
  import('./mob_promo.css').then(() => {});
else
  import('./promo.css').then(() => {});


function PromoForm({promo = {articles:[],reduction:30,title:null,start:null,end:null}}) {
  const [meta,setMeta] = useState([]);
  const [articles,setArticles] = useState([]);
  const [promos, setPromos] = useState([
    {
       label: <div><h5 style={{margin:'0px'}}>Promo du ramadan</h5><span style={{fontSize:'small',color:'gray',marginRight:'20px'}}>Ref:3</span> <span style={{fontSize:'small',color:'gray'}}>Reduction;30%</span></div>,
       value:3,
       title: 'Promo du ramadan',
       reduction:30,
       id:3,
       articles:[]
    }
  ]);
  const [Loadings,setLoadings] = useState({promo:false,rayons:false,articles:false});
  const [_promo,setPromo] = useState(promo);
  const [notif, setNotif] = useState({text:'',color:'black'});
  const [DefaultSelectedArticles,setDefaultSelectedArticles] = useState([]);
  const [categories,setCategories] = useState([]);
  const promos_ref = useRef();
  const [UserState,setUserState] = useContext(UserContext);
  const navigator = useNavigate();
  const fetchData = useFetch();

  const updateArticles = (_articles)=>{
      
      const FormatArticle = (art)=>
      {
          return(
              <div style={{textAlign:'left',paddingLeft:'10px'}}>
                  <img src={MediaUrl(art.image)} style={{verticalAlign:'middle',width:'40px',height:'40px',borderRadius:'20px',display:'inline-block'}} />
                  <div style={{marginLeft:'20px',verticalAlign:'middle',display:'inline-block'}}>
                      <h5 style={{margin:'2px'}}>{art.title}</h5>
                      <span style={{color:'gray'}}>Reference : {art.id}</span>
                  </div>
              </div>
          );
      }

      let arr = [];
      let defaults = [];
      _articles.forEach(art=>{
          arr.push({label:FormatArticle(art),value:art.id});
          if(promo.articles.includes(art.id))
              defaults.push({label:FormatArticle(art),value:art.id});
      
      });
      setArticles(arr);
      setDefaultSelectedArticles(defaults);
  }

  useEffect(()=>{
    if(!UserState.auth)
    {
        navigator('/')
    }
  },[UserState.auth])

  useEffect(()=>{
      setLoadings({...Loadings,promo:true,rayons:true});
      fetchData.GetData('promo/').then((result)=>{
          if(result.result)
          {
            let arr = [];
            result.promos.forEach((pro)=>{
              arr.push({...pro,
                label:<div><h5 style={{margin:'0px'}}>{pro.title}</h5><span style={{fontSize:'small',color:'gray',marginRight:'20px'}}>Ref:{pro.id}</span> <span style={{fontSize:'small',color:'gray'}}>Reduction : {pro.reduction}%</span></div>,
                value:pro.id
              });
            })
             setPromos([...arr]);
          }
          setLoadings({...Loadings,promo:false});;
      });

      var params = new URLSearchParams({
        meta:true
    });
      fetchData.GetData(`meta/articles/?${params}`).then((result)=>{
        console.log(result);
        if(result.result)
        {
            setMeta(result.meta);
            console.log(Object.values(result.meta[0]));
            setCategories(Object.values(result.meta[0])[0]);
            updateArticles(result.articles);
        }
        setLoadings({...Loadings,rayons:false});
    });
  },[])

  const HandleSelectCategory = async (value)=>
  {
      var params = new URLSearchParams({
        category:value
    })
    fetchData.GetData(`meta/articles/?${params}`).then((result)=>{
        if(result.result)
        {
            updateArticles(result.articles);
        }
    })
  }

  const HandleSelectArticle = (value, SelectedItems)=>{
      if(!!SelectedItems)
      {
          let arr = [];
          SelectedItems.forEach((item)=>{
              if(articles.includes(item))
              {
                  arr.push(item.value);
              }
          });
          setPromo({..._promo,articles:arr});
      }
  }

  const CreatePromo = async ()=>
  {
      console.log(_promo);
      fetchData.PostData(_promo,'promo/').then((result)=>{
          if(result.result)
          {
            let arr = [];
            result.promos.forEach((pro)=>{
              arr.push({...pro,
                label:<div><h5 style={{margin:'0px'}}>{pro.title}</h5><span style={{fontSize:'small',color:'gray',marginRight:'20px'}}>Ref:{pro.id}</span> <span style={{fontSize:'small',color:'gray'}}>Reduction : {pro.reduction}%</span></div>,
                value:pro.id
              });
              setNotif({text:'Ajouté avec succès',color:'green'});
              setTimeout(()=>{setNotif({text:'',color:'black'});},5000);
            })
            setPromos([...arr]);
          }
          else
          {
            setNotif({text:'Erreur Serveur',color:'orangered'});
            setTimeout(()=>{setNotif({text:'',color:'black'});},5000);
          }
      })
  }

  const UpdatePromo = async ()=>
  {

  }

  const DeletePromo = async ()=>
  {
    if(_promo.id === undefined || _promo.id === null)
      return
    fetchData.DeleteData({id:_promo.id},'promo/').then((result)=>{
      console.log(result);
      if(result.result)
      {
        let arr = [];
        result.promos.forEach((pro)=>{
          arr.push({...pro,
            label:<div><h5 style={{margin:'0px'}}>{pro.title}</h5><span style={{fontSize:'small',color:'gray',marginRight:'20px'}}>Ref:{pro.id}</span> <span style={{fontSize:'small',color:'gray'}}>Reduction : {pro.reduction}%</span></div>,
            value:pro.id
          });
          setNotif({text:'Supprimé avec succès',color:'green'});
          setTimeout(()=>{setNotif({text:'',color:'black'});},5000);
        })
        setPromos([...arr]);
      }
    })
  }

  const [submitButton,setSubmitButton] = useState({text:'Enregister',bg:'lightgreen',onclick:CreatePromo});

  useEffect(()=>{
      if(!!_promo.id)
      {
        setSubmitButton({text:'Modifier',bg:'lightblue',onclick:UpdatePromo});
      }
      else
      {
        setSubmitButton({text:'Enregister',bg:'lightgreen',onclick:CreatePromo});
      }
  },[_promo])

  const OnPromoSelectChange = (val,action)=>
  {
      if(!!val)
        setPromo(val);
      else if(action!=='menu-close' || action!=='input-blur')
        setPromo(promo)
  }

  return (
    <div id='promo'>
      <fieldset className='promo-fieldset'>
          <label className='promo-label'>Promos : </label>
          <div className='promo-input' style={{border:'none'}}>
              <Select isLoading={Loadings.promo} isClearable={true} isSearchable={false} ref={promos_ref} isMulti={false} options={promos} onInputChange={(val,action)=>{}} onChange={(val, action)=>{OnPromoSelectChange(val)}}/>
          </div>
      </fieldset>
      <fieldset className='promo-fieldset'>
          <div className='promo-div'>
              <p style={{color:notif.color, margin:'auto'}}>{notif.text}</p>
          </div>
          <div className='promo-div'>
            <label className='promo-label'>Titre</label>
            <input value={_promo.title} onChange={e=>{setPromo({..._promo,title:e.target.value})}} className='promo-input' type='text' placeholder='Ajouter un titre' />
          </div>
          <div className='promo-div'>
            <label className='promo-label'>Reduction</label>
            <div className="promo-div-input" >
              <input value={_promo.reduction} onChange={e=>{setPromo({..._promo,reduction:Number(e.target.value)})}} style={{verticalAlign:'middle',width:'70%',marginRight:'10px',display:'inline-block'}} className='promo-input' type='range' min={1} max={100} step={1} />
              <span style={{width:'10%',fontWeight:'bold',display:'inline-block',verticalAlign:'middle'}}>(-{_promo.reduction}%)</span>
            </div>
          </div>
          <div className='promo-div'>
            <label className='promo-label'>Dates : </label>
            <div className='promo-div-input'>
              <label style={{marginRight:'10px',marginTop:'8px'}}>Deput </label>
              <input value={_promo.start} onChange={e=>{setPromo({..._promo,start:e.target.value})}}  type='date' style={{verticalAlign:'middle',width:'30%',marginRight:'30px'}} className='promo-input' />
              <label style={{marginRight:'10px',marginTop:'8px'}}>Fin </label>
              <input value={_promo.end} onChange={e=>{setPromo({..._promo,end:e.target.value})}} type='date' style={{width:'30%'}} className='promo-input' />
            </div>
          </div>
          <div className="promo-div">
              <label className="promo-label">Articles : </label>
              <div className="promo-div-input">
                  <div style={{width:'100%'}}>
                      <div className="promo-div-row">
                          <label className="promo-div-label" >Rayons :</label>
                          <select className="promo-input"  onChange={e=>{meta.forEach(element => {
                              console.log(e.target.value, Object.keys(element)[0]);
                              if(e.target.value === Object.keys(element)[0])
                                {
                      
                                  setCategories(element[e.target.value]);console.log(meta);

                                }
                              });}}>  
                              {meta.map((m)=>{
                                  return(Object.keys(m).map(key=>(<option key={key}>{key}</option>)));
                              })}
                          </select>
                      </div>
                      <div className="promo-div-row">
                          <label className="promo-div-label">Categories :</label>
                          <select className="promo-input" onChange={e=>{HandleSelectCategory(e.target.value)}}>
                              {categories.map(cat=>{
                                  return(Object.keys(cat).map(key=>(<option key={key} value={cat[key]}>{key}</option>)))
                              })}
                          </select>
                      </div>
                      <div className="promo-div-row">
                          <label className="promo-div-label">Articles :</label>
                          <div className="promo-input" style={{display:'inline-block',border:'none'}}>
                              <Select isSearchable={false} defaultValue={DefaultSelectedArticles} onChange={(value,action)=>{HandleSelectArticle(action,value)}} loading={false} isMulti={true} options={articles} />
                          </div>
                      </div>
                  </div>
              </div>
              <MobileView>
                  <input type="button" value={'scan'} style={{position:'relative',width:'50%',borderRadius:'5px',backgroundColor:'blue',margin:'auto',marginTop:'10px',color:'white',height:'30px',border:'none'}} />
              </MobileView>
          </div>
          <div>
            <input onClick={e=>{submitButton.onclick();}} type='button' value={submitButton.text} style={{backgroundColor:submitButton.bg, padding:'10px 20px 10px 20px',border:'none',borderRadius:'5px'}}/>
            <input disabled={(_promo.id===null || _promo.id===undefined)} onClick={e=>{DeletePromo()}} type='button' value={"Supprimer"} style={{backgroundColor:'#FFCBCC', padding:'10px 20px 10px 20px',border:'none',borderRadius:'5px'}}/>
            <TeachButton id={_promo.id} target={'promo'} width={'50%'} />
          </div>
      </fieldset>
    </div>
  )
}

export default PromoForm;
